export default __webpack_public_path__ + "static/media/STL-Investors-Meet-June12.163c565e.pdf";